import {
  ContactType,
  PatientContactAnswerSnapshot,
} from '../../generated/graphql';

export function formatContactTypeLabel(
  contactType: ContactType | null | undefined,
): string {
  if (contactType == null) {
    return 'Contact';
  }
  return String(contactType)
    .toLowerCase()
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function formatPatientContactSnapshotAnswer(
  snapshot: PatientContactAnswerSnapshot | null | undefined,
): string {
  if (!snapshot) {
    return '—';
  }
  const first = (snapshot.firstName ?? '').trim();
  const last = (snapshot.lastName ?? '').trim();
  const nameJoined = [first, last].filter(Boolean).join(' ').trim();
  const typeLabel = snapshot.contactType
    ? formatContactTypeLabel(snapshot.contactType as ContactType)
    : '';
  const email = (snapshot.email ?? '').trim();
  const phone = (snapshot.phoneNumber ?? '').trim();
  const relationship = (snapshot.relationshipDescription ?? '').trim();
  const addressLine = snapshot.addressStreet
    ? [
        snapshot.addressStreet,
        snapshot.addressCity,
        snapshot.addressState,
        snapshot.addressPostalCode,
        snapshot.addressCountry,
      ]
        .filter(Boolean)
        .join(', ')
    : '';

  const lines: string[] = [];
  if (nameJoined) {
    lines.push(`**Name:** ${nameJoined}`);
  } else {
    if (first) {
      lines.push(`**First name:** ${first}`);
    }
    if (last) {
      lines.push(`**Last name:** ${last}`);
    }
  }
  if (email) {
    lines.push(`**Email:** ${email}`);
  }
  if (phone) {
    lines.push(`**Phone:** ${phone}`);
  }
  if (relationship) {
    lines.push(`**Relationship:** ${relationship}`);
  }
  if (addressLine) {
    lines.push(`**Address:** ${addressLine}`);
  }
  if (typeLabel) {
    lines.push(`**Contact type:** ${typeLabel}`);
  }

  return lines.length > 0 ? lines.join('\n') : '—';
}
